import { render, staticRenderFns } from "./add-eds.vue?vue&type=template&id=21c816ac&"
import script from "./add-eds.vue?vue&type=script&lang=js&"
export * from "./add-eds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports